import { render } from "./CreateSitePopUp.vue?vue&type=template&id=2c8dcd01&scoped=true"
import script from "./CreateSitePopUp.js?vue&type=script&lang=js"
export * from "./CreateSitePopUp.js?vue&type=script&lang=js"

import "./CreateSitePopUp.vue?vue&type=style&index=0&id=2c8dcd01&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c8dcd01"]])

export default __exports__